import { render, staticRenderFns } from "./checkApi.vue?vue&type=template&id=70258cde&scoped=true&"
import script from "./checkApi.vue?vue&type=script&lang=js&"
export * from "./checkApi.vue?vue&type=script&lang=js&"
import style0 from "./checkApi.vue?vue&type=style&index=0&id=70258cde&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70258cde",
  null
  
)

export default component.exports